import { NgModule } from '@angular/core';
import { DefaultUrlSerializer, RouterModule, Routes, UrlSerializer, UrlTree } from '@angular/router';
import { QuickLinksNavigateComponent } from './feature/productlines/quicklinks/quicklinks-navigation.component';
import { EligibilityGuard } from './guards/eligibility.guard';
import { AccessDeniedComponent } from './feature/accessdenied/accessDenied.component';
export class CustomUrlSerializer extends DefaultUrlSerializer {
  parse(url: string): UrlTree {
    url = url.replace(/\(/g, '%28').replace(/\)/g, '%29');
    return super.parse(url);
  }

  serialize(tree: UrlTree): string {
    const url = super.serialize(tree);
    return url.replace(/%28/g, '(').replace(/%29/g, ')');
  }

}

const routes: Routes = [
  // Home route - can be migrated to standalone component later
  {
    path: '',
    loadChildren: () => import('./feature/home/home.module').then(m => m.HomeModule),
    canActivate: [EligibilityGuard],
    title: 'Home'
  },
  // Document route - can be migrated to standalone component later
  {
    path: 'document',
    loadChildren: () => import('./feature/document/document.module').then(m => m.DocumentModule),
    title: 'Document'
  },
  // Product line route - can be migrated to standalone component later
  {
    path: 'productline',
    loadChildren: () => import('./feature/productlines/productlines.module').then(m => m.ProductLinesModule),
    canActivate: [EligibilityGuard],
    title: 'Product Line'
  },
  // Document search route - can be migrated to standalone component later
  {
    path: 'searchresults',
    loadChildren: () => import('./feature/documentSearch/documentSearch.module').then(m => m.DocumentSearchModule),
    canActivate: [EligibilityGuard],
    title: 'Search Results'
  },
  // Using modern loadComponent approach for standalone components
  {
    path: 'quicklinksnavigate',
    loadComponent: () => import('./feature/productlines/quicklinks/quicklinks-navigation.component').then(c => c.QuickLinksNavigateComponent),
    title: 'Quick Links'
  },
  {
    path: 'access-denied',
    loadComponent: () => import('./feature/accessdenied/accessDenied.component').then(c => c.AccessDeniedComponent),
    title: 'Access Denied'
  },  // Wildcard route - now using loadComponent approach for the standalone component
  { 
    path: '**',
    loadComponent: () => import('./shared/redirect/redirect.component').then(c => c.RedirectComponent),
    title: 'Page Not Found'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload' })],
  providers: [{ provide: UrlSerializer, useClass: CustomUrlSerializer }],
  exports: [RouterModule]
})
export class AppRoutingModule { }
